import styled from 'styled-components';

export default styled.div`
  background: ${props => props.theme.darkGray5};
  border-bottom: ${props => props.theme.border};
  min-height: 220px;
`;
